/** Phase 5 — repository, PR, commit, branch list styling tokens. */

export const repoCard =
  'bg-dark-surface border border-dark-border rounded-xl p-4 hover:border-dark-border-glow hover:shadow-lg hover:shadow-black/30 transition-all duration-200 cursor-pointer';

export const commitHashClass =
  'font-mono text-brand-teal-light text-xs bg-dark-base px-1.5 py-0.5 rounded';

export const prTitleClass = 'text-slate-200 font-medium text-sm hover:text-white transition-colors';

export const prMetaClass = 'text-slate-500 text-xs mt-0.5';

export const listRowClass =
  'border-b border-dark-border hover:bg-dark-elevated/50 transition-colors cursor-pointer';

export const diffViewer = {
  container: 'overflow-hidden rounded-xl border border-dark-border bg-dark-base font-mono text-sm',
  lineNumbers: 'w-12 select-none pr-3 text-right text-slate-600',
  added: 'border-l-2 border-emerald-500 bg-emerald-900/20 text-emerald-200',
  removed: 'border-l-2 border-red-500 bg-red-900/20 text-red-200',
  context: 'text-slate-400',
  hunk: 'bg-dark-elevated px-3 py-1 text-xs text-slate-500',
};

/** PR status icon colour: open, merged, closed, draft. */
export function prStatusIconClass(pr) {
  if (pr?.draft) return 'text-amber-400';
  if (pr?.merged) return 'text-brand-purple-light';
  const state = String(pr?.state || 'open').toLowerCase();
  if (state === 'closed') return 'text-slate-500';
  return 'text-emerald-400';
}

export const reviewStatusClass = {
  approved: 'text-emerald-300',
  changes_requested: 'text-red-300',
  pending: 'text-amber-300',
};

export function branchAheadBehindClass(type) {
  return type === 'ahead' ? 'text-emerald-400' : 'text-amber-400';
}

/** Derive HTTPS clone URL from a GitHub web URL. */
export function githubCloneUrl(htmlUrl) {
  const href = typeof htmlUrl === 'string' ? htmlUrl.trim().replace(/\/+$/, '') : '';
  if (!href) return '';
  if (href.endsWith('.git')) return href;
  return `${href}.git`;
}
